import { gql, useQuery } from '@apollo/client';
export const NEAREST_AIRPORT_RESULTS_QUERY = gql `
    query GetNearestAirports($airportCode: String!) {
        getNearestAirports(airportCode: $airportCode) {
            airportCode
        }
    }
`;
export function useGetNearestAirports(airportCode, skipQuery = false) {
    var _a, _b;
    const { data, error, loading } = useQuery(NEAREST_AIRPORT_RESULTS_QUERY, {
        variables: {
            airportCode,
        },
        ssr: false,
        skip: !airportCode || skipQuery,
    });
    const airportCodes = (_b = (_a = data === null || data === void 0 ? void 0 : data.getNearestAirports) === null || _a === void 0 ? void 0 : _a.map((airport) => airport.airportCode)) !== null && _b !== void 0 ? _b : [];
    return { airportCodes, error, loading };
}
